// extracted by mini-css-extract-plugin
export var container = "ItsAllConected-module--container--0iJ3L";
export var firstGroup = "ItsAllConected-module--first-group--0swH3";
export var link = "ItsAllConected-module--link--8I96k";
export var paragraph = "ItsAllConected-module--paragraph--CV1u-";
export var secondGroup = "ItsAllConected-module--second-group--FnLyp";
export var secondParagraph = "ItsAllConected-module--second-paragraph--TYX+i";